import React from "react";
import PropTypes from "prop-types";

import { StyledTypography } from "./style";

const Typography = (props) => {
  const { fontWeight = "regular", ...otherProps } = props;

  return <StyledTypography fontWeight={fontWeight} {...otherProps} />;
};

Typography.propTypes = {
  ...StyledTypography.propTypes,
  fontWeight: PropTypes.oneOf([
    "regular",
    "medium",
    "semibold",
    "bold",
    "extrabold",
  ]),
};

export default Typography;
